import Link from 'next/link';

interface NavBarProps {
  styles?: string;
}

const NavBarTitle = ({ styles }: NavBarProps) => {
  return (
    <nav
      className={`navbar navbar-expand-lg navbar-light ${
        styles === undefined ? '' : styles
      }`}
      role="navigation"
      style={{ minHeight: '60px' }}
    >
      <Link href="/" legacyBehavior>
        <a className={`navbar-brand`}>
          <img
            src={`${process.env.NEXT_PUBLIC_BASE_URL}/fachhochschule-nordwestschweiz-fhnw-logo.svg`}
            alt="FHNW - Fachhochschule Nordwestschweiz"
            height={40}
            width={173.594}
          />
          Projekttitel
        </a>
      </Link>
      <span className="navbar-title d-sm-none">Projekttitel</span>
    </nav>
  );
};

export default NavBarTitle;
